/**
 * Ensure coach redirection to CP.
 */
function ensureCoachRedirection({ req, res, locals }, next) {
  const { activeUser } = locals;

  if (!activeUser) return next();

  const isCoach =
    activeUser.permissions && activeUser.permissions.indexOf("coach") > -1;

  const justLoggedIn = req.cookies.justLoggedIn;

  // remove cookie to allow exiting the CP after login
  // check login.js to see where the cookie is set
  res.cookie("justLoggedIn", "null", { path: "/" });
  if (isCoach && justLoggedIn !== "null") {
    const redirectPage = `/coaching-portal`;
    if (redirectPage !== req.pathname) return res.redirect(redirectPage);
  }

  return next();
}

export default ensureCoachRedirection;
